import React from "react";
import { Box, Circle, Avatar, Flex } from "@chakra-ui/react";
import { BsBell } from "react-icons/bs";
import AccountSwitcher from "../AccountSwitcher/AccountSwitcher";

const RightControls = ({
  isMobile,
  pageColor,
  userProfile,
  unReadNotifications,
  navigate,
}) => {
  if (!isMobile) {
    return (
      <Flex
        minWidth={0}
        justifyContent={"flex-end"}
        alignItems="center"
        gap={3}
      >
        <Box minW={0} mr="8px" display="flex" alignItems="center">
          <AccountSwitcher />
        </Box>

        <Circle
          width="48px"
          height="48px"
          border="1px solid #c4c4c4"
          mr="8px"
          cursor="pointer"
          position={"relative"}
          onClick={() => navigate("/notification")}
        >
          <Circle
            width={["16px"]}
            height="16px"
            position="absolute"
            top="7px"
            left="10px"
            color={"#fff"}
            bg="red"
            fontSize="10px"
          >
            {unReadNotifications?.length}
          </Circle>
          <BsBell size={25} color={pageColor} />
        </Circle>

        <Box minW={0} mr="8px" display="flex" alignItems="center">
          <Avatar
            src={userProfile?.image}
            bg={pageColor}
            name={userProfile?.name}
            onClick={() => navigate("/profile")}
            cursor="pointer"
          />
        </Box>
      </Flex>
    );
  }

  return (
    <Box mt={2} px={4} display="flex" flexDirection="column" gap={3}>
      <Box width="100%" display="flex" justifyContent="center">
        <Box width="100%" maxW="300px">
          <AccountSwitcher />
        </Box>
      </Box>
      <Box width="100%" display="flex" justifyContent="center">
        <Box width="100%" maxW="300px">
          <Box display="flex" justifyContent="center">
            <Circle
              width="40px"
              height="40px"
              border="1px solid #c4c4c4"
              cursor="pointer"
              position={"relative"}
              onClick={() => navigate("/notification")}
            >
              <Circle
                width={["14px"]}
                height="14px"
                position="absolute"
                top="6px"
                left="8px"
                color={"#fff"}
                bg="red"
                fontSize="10px"
              >
                {unReadNotifications?.length}
              </Circle>
              <BsBell size={20} color={pageColor} />
            </Circle>
          </Box>
        </Box>
      </Box>
      <Box width="100%" display="flex" justifyContent="center">
        <Box width="100%" maxW="300px" display="flex" justifyContent="center">
          <Avatar
            src={userProfile?.image}
            bg={pageColor}
            name={userProfile?.name}
            onClick={() => navigate("/profile")}
            cursor="pointer"
            size="sm"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default RightControls;
